import React from 'react';

export const RenderTubetto = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      <g style={{ transformOrigin: '0px 150px' }}>

        {/* Corpo principale esagonale */}
        <path
          d="M-154,-52 L154,-52 L195,-93 L350,-93 L350,0 L350,93 L195,93 L154,52 L-154,52 L-195,93 L-350,93 L-350,0 L-350,-93 L-195,-93 L-154,-52"
          style={{
            fill: color,
            stroke: 'rgb(0, 0, 0)',
            strokeLinejoin: 'round',
            strokeWidth: '8px'
          }}
        />

        {/* Dettagli interni del tubetto - esagono centrale */}
        <path
          d="M-154,52 L154,52 L154,0 L154,-52 L-154,-52 L-154,0 L-154,52"
          style={{
            fill: 'none',
            stroke: 'rgb(33, 37, 41)',
            strokeLinejoin: 'round',
            strokeWidth: '4px'
          }}
        />

        {/* Linee di divisione interne verticali */}
        <path d="M195,-93 L195,0" stroke="#212529" strokeWidth="4" fill="none" />
        <path d="M195,93 L195,0" stroke="#212529" strokeWidth="4" fill="none" />
        <path d="M-195,93 L-195,0" stroke="#212529" strokeWidth="4" fill="none" />
        <path d="M-195,-93 L-195,0" stroke="#212529" strokeWidth="4" fill="none" />
        </g>
      </g>
  );
};

